import { ABTest, ABTestName } from '@/shared/types/ABTest';

type GetABTest = {
  testName: ABTestName | ABTestName[];
  tests?: ABTest[];
};

export const getABTest = ({ testName, tests }: GetABTest) => {
  if (!tests) {
    return [];
  }

  if (Array.isArray(testName)) {
    return tests.filter((test) => testName.includes(test.name as ABTestName));
  }

  return tests.filter((test) => test.name === testName);
};
